export default class ScrollTo {
  constructor() {
    this.scroll = document.querySelectorAll(".jsScrollTo");
    this.init();
  }

  scrollToElement(i) {
    let top = document.getElementById(i.dataset.id).offsetTop;

    window.scroll({
      top: top,
      left: 0,
      behavior: "smooth"
    });
  }

  init() {
    for (let i = 0; i < this.scroll.length; i++) {
      this.scroll[i].addEventListener("click", () => {
        this.scrollToElement(this.scroll[i]);
      });
    }
  }
}
